import {
  React,
  Component
} from 'imports/CommonImports';

import {
  Checkbox,
} from 'material-ui';

const styles = {
  column: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    justifyContent: 'space-around'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flex: '1',
  },
  labelSection: {
    flex: '1',
    padding: '1em',
    display: 'flex',
    justifyContent: 'space-around'
  },
  fourSection: {
    flex: '5',
    padding: '1em',
  },
  label: {
    textAlign: 'right',
    color: '#212F55',
  },
  optionContainer:{
    flex: 4,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    fontStyle: 'italic',
    marginTop: '2em'
  },
  option: {
    display: 'table-cell',
    flex: 1,
    width: '25%'
  },
  fakeOption: {
    display: 'table-cell',
    visibility: 'hidden',
    flex: 1,
    width: '25%'
  },
  lightLato: {
    fontWeight: '300',
    color: '#212F55'
  }
}
export default class FilterOptionSelect extends Component {

  state = {
    solutions: ['Productos/Servicios', 'Procesos', 'Comercial o Marketing', 'Gestión'],
    novelty: ['Nuevo para la empresa', 'Nuevo a nivel país', 'Nuevo a nivel global'],
    benefits: ['Generación de ingresos', 'Reducción de costos'],
  }
  render() {
    return (
      <div style={{display: 'flex'}}>
        <div style={{...styles.column, ...styles.labelSection}}>
          <p style={styles.label}>Tipo de solución</p>
          <p style={styles.label}>Grado de novedad</p>
          <p style={styles.label}>Tipo de beneficio</p>
        </div>
        <div style={{...styles.column, ...styles.fourSection}}>
          <div style={styles.optionContainer}>
            {this.state.solutions.map((solution, i) => {
              return(
                <Checkbox
                  labelStyle={styles.lightLato}
                  style={styles.option}
                  key={i}
                  label={solution}
                  checked={this.props.solutionType.includes(solution)}
                  disabled={true}
                />
              );
            })}
          </div>
        <div>
          <div style={styles.optionContainer}>
            {this.state.novelty.map((novelty, i) => {
              return(
                <Checkbox
                  labelStyle={styles.lightLato}
                  style={styles.option}
                  key={i}
                  label={novelty}
                  checked={this.props.novelty === novelty}
                  disabled={true}
                />
              );
            })}
            <Checkbox
              labelStyle={styles.lightLato}
              style={styles.fakeOption}
              label="Fake checkbox"
            />
          </div>

          </div>
          <div style={styles.optionContainer}>
            {this.state.benefits.map((benefit, i) => {
              return(
                <Checkbox
                  labelStyle={styles.lightLato}
                  style={styles.option}
                  key={i}
                  label={benefit}
                  checked={this.props.benefitType.includes(benefit)}
                  disabled={true}
                />
              );
            })}
            <Checkbox
              labelStyle={styles.lightLato}
              style={styles.fakeOption}
              label="Fake checkbox"
            />
            <Checkbox
              labelStyle={styles.lightLato}
              style={styles.fakeOption}
              label="Fake checkbox"
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/FilterOptionSelect.js